import { Axios } from 'axios'

export type ResponseTenant = {
  tenantId: string;
  tenantName: string;
  selected: string;
}

export interface TenantService {
  list(): Promise<ResponseTenant[]>;
  save(tenantId: string): Promise<void>;
}

export class TenantServiceImpl implements TenantService {
  constructor (http: Axios) {
    this.http = http
  }

  private readonly http: Axios
  private readonly baseUrl = 'admin/tenant'

  async list (): Promise<ResponseTenant[]> {
    const { data } = await this.http.get(this.baseUrl)
    return data
  }

  async save (tenantId: string): Promise<void> {
    await this.http.post(this.baseUrl, { tenantId: tenantId })
  }
}
